import React from 'react';

const NoticePage = () => {
  return (
    <div className="notice-page"> {/* 未使用 */}
      <h2 className="page-title" style={{ textAlign: 'center' }}>お知らせ</h2>
      <section style={{ marginBottom: '2em' }}>
        <h3 style={{ textAlign: 'left', fontSize: '0.6em' }}>【お知らせ】</h3>
        <p style={{ textAlign: 'left', lineHeight: '0.3', fontSize: '0.5em', paddingLeft: '2em' }}>2026.4.1　共通消耗品管理システムをリリースしました。</p>
        <p style={{ textAlign: 'left', lineHeight: '0.3', fontSize: '0.5em', paddingLeft: '2em' }}>　</p>
        <p style={{ textAlign: 'left', lineHeight: '0.3', fontSize: '0.5em', paddingLeft: '2em' }}>　</p>
        <p style={{ textAlign: 'left', lineHeight: '0.3', fontSize: '0.5em', paddingLeft: '2em' }}>　</p>
        <p style={{ textAlign: 'left', lineHeight: '0.3', fontSize: '0.5em', paddingLeft: '2em' }}>　</p>
      </section>
      <section style={{ marginBottom: '2em' }}>
        <h3 style={{ textAlign: 'left', fontSize: '0.6em' }}>【システムについて】</h3>
        <p style={{ textAlign: 'left', lineHeight: '0.3', fontSize: '0.5em', paddingLeft: '2em' }}>本システムはサーバレスアーキテクチャにて構成しているため、</p>
        <p style={{ textAlign: 'left', lineHeight: '0.3', fontSize: '0.5em', paddingLeft: '2em' }}>ロード時間が長くなることがあります。</p>
        <p style={{ textAlign: 'left', lineHeight: '0.3', fontSize: '0.5em', paddingLeft: '2em' }}>ご迷惑をお掛けしますが、ご了承ください。</p>
        <p style={{ textAlign: 'left', lineHeight: '0.3', fontSize: '0.5em', paddingLeft: '2em', marginTop: '2.0em' }}>※自社開発システムのため、改善のための仕様変更を高頻度で行う</p>
        <p style={{ textAlign: 'left', lineHeight: '0.3', fontSize: '0.5em', paddingLeft: '3em' }}>場合があります</p>
      </section>
      <section style={{ marginBottom: '1em' }}>
        <h3 style={{ textAlign: 'left', fontSize: '0.6em' }}>【連絡先】</h3>
        <p style={{ textAlign: 'left', lineHeight: '0.3', fontSize: '0.5em', paddingLeft: '2em' }}>システムに関するご意見・要望・問題などありましたら、</p>
        <p style={{ textAlign: 'left', lineHeight: '0.3', fontSize: '0.5em', paddingLeft: '2em' }}>下記までご連絡ください。</p>
        <p style={{ textAlign: 'left', lineHeight: '0.3', fontSize: '0.5em', paddingLeft: '2em' }}>連絡の際、件名にシステム名を入れるようお願いします。</p>
        <a style={{
          textAlign: 'left',
          lineHeight: '2.0',
          fontSize: '0.5em',
          paddingLeft: '2em',
          display: 'block',
          color: '#66CCFF',
          textDecoration: 'underline',
        }}
          href="mailto:CMbxZ220tkyk-cloud@mail.advics.co.jp?subject=【連絡】信頼性業務依頼システム">
            CMbxZ220tkyk-cloud@mail.advics.co.jp</a>
        {/*<p style={{ textAlign: 'left', lineHeight: '2.0', fontSize: '0.5em' }}>　　CMbxZ220tkyk-cloud@mail.advics.co.jp</p>*/}
      </section>
    </div>
  );
};

export default NoticePage; 